import { useMutation } from '@tanstack/react-query';
import { createPortalSession } from '@api/billing';

export function useBillingPortal() {
  return useMutation({
    mutationFn: createPortalSession,
  });
}
